var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide-menu box-shadow"
  }, [_c('thumbnail', {
    staticStyle: {
      "padding": "30px 0"
    },
    attrs: {
      "text": _vm.user.name,
      "font-size": 16
    }
  }), _vm._v(" "), _c('el-menu', {
    staticClass: "fixed-menu",
    attrs: {
      "default-active": _vm.menuActive,
      "mode": "vertical",
      "unique-opened": true,
      "router": ""
    },
    on: {
      "open": _vm.openSubMenu
    }
  }, [_vm._l((_vm.menus), function(item, index) {
    return [(item.list.length) ? _c('el-submenu', {
      key: index,
      attrs: {
        "index": _vm.getRoute(item.value, item.text)
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: _vm.getIcon(item.value)
    }), _vm._v(" "), _c('span', {
      staticClass: "folded-hide"
    }, [_vm._v(_vm._s(item.text))])]), _vm._v(" "), (item.value === '/interview/1') ? _c('el-menu-item', {
      attrs: {
        "index": "/interview/0"
      }
    }, [_vm._v("所有面试")]) : _vm._e(), _vm._v(" "), _vm._l((item.list), function(sub, subIndex) {
      return [_c('el-menu-item', {
        key: subIndex,
        attrs: {
          "index": _vm.getRoute(sub.value)
        }
      }, [_vm._v(_vm._s(sub.text))])]
    })], 2) : _c('el-menu-item', {
      key: index,
      attrs: {
        "index": _vm.getRoute(item.value)
      }
    }, [_c('i', {
      class: _vm.getIcon(item.value)
    }), _c('span', [_vm._v(_vm._s(item.text))])])]
  })], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffa713e6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/menu.vue
// module id = null
// module chunks = 